import { useCallback, useState } from 'react'

const useSearchHandler = ({ alertHandler, requester }) => {
  const { clearAlerts } = alertHandler
  const { request } = requester
  const [searchTerm, setSearchTerm] = useState('')
  const [hasSearched, setHasSearched] = useState(false)
  const [results, setResults] = useState([])

  const updateSearchTerm = useCallback(newSearchTerm => {
    setSearchTerm(newSearchTerm)
    if (!newSearchTerm) {
      setHasSearched(false)
    }
  }, [])

  const performSearch = useCallback(
    async (apiEndpoint, { minSearchLength = 3, params } = {}) => {
      // If search is entirely empty or too short
      if (
        minSearchLength > 0 &&
        (!searchTerm || searchTerm.length < minSearchLength)
      ) {
        setHasSearched(!!searchTerm)
        setResults([])
        return
      }

      // Clear any existing alerts to prevent confusion
      clearAlerts()

      const { data } = await request(apiEndpoint, {
        params: { ...params, ...(searchTerm && { query: searchTerm }) },
      })
      if (data) {
        setResults(data.results)
        setHasSearched(true)
      } else {
        setResults([])
        setHasSearched(false)
      }
    },
    [clearAlerts, searchTerm, request]
  )

  // Expose all state components
  return {
    // States
    searchTerm,
    setSearchTerm,
    hasSearched,
    setHasSearched,
    results,
    setResults,
    // Helper functions and wrappers
    updateSearchTerm,
    performSearch,
  }
}

export { useSearchHandler }
